<script>
import Layout from "../../../layouts/main";
import Style from "@/views/layouts/style";
import PageHeader from '@/components/Page-header';
import appConfig from "../../../../../app.config";


/**
 * Form elements component
 */
export default {
 page: {
    title: "Comité Copasst",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: {
    Layout,
    Style,
    PageHeader,
  },
  data() {
    return {
      title: "",
      items: [
        {
          text: "Base de conocimiento",
          href: "/forms/general",
        },
        {
          text: "Comité Copasst",
          active: true,
        },
      ],
      text: `
          Ad leggings keytar, brunch id art party dolor labore. Pitchfork yr enim lo-fi before they sold out qui. Tumblr farm-to-table bicycle rights whatever. Anim keffiyeh carles cardigan. Velit seitan mcsweeney's photo booth 3 wolf moon irure. Cosby sweater lomo jean shorts, williamsburg hoodie minim qui you probably haven't heard of them et cardigan trust fund culpa biodiesel wes anderson aesthetic. Nihil tattooed accusamus, cred irony biodiesel keffiyeh artisan ullamco consequat.
        `,
      text2: `Labore sit culpa commodo elit adipisicing sit aliquip elit proident voluptate minim mollit nostrud aute reprehenderit do. Mollit excepteur eu Lorem ipsum anim commodo sint labore Lorem in exercitation velit incididunt. Occaecat consectetur nisi in occaecat proident minim enim sunt reprehenderit exercitation cupidatat et do officia. Aliquip consequat ad labore labore mollit ut amet. Sit pariatur tempor proident in veniam culpa aliqua excepteur elit magna fugiat eiusmod amet officia.`,
    };
  },
  methods: {
    /**
     * Vuelve a la página anterior real. Esta vista se abre tanto desde la base
     * de conocimiento como desde su ítem, así que no se puede fijar el destino.
     * Si no hay historial (entrada directa o refresh) cae a la base de conocimiento.
     */
    goBack() {
      if (window.history.length > 1) {
        this.$router.go(-1);
      } else {
        this.$router.push("/forms/general");
      }
    },

    /**
     * Scrollspy
     */
    scrollIntoView(evt) {
      evt.preventDefault();
      const href = evt.target.getAttribute("href");
      const el = href ? document.querySelector(href) : null;
      if (el) {
        this.$refs.content.scrollTop = el.offsetTop;
      }
    },
    
  },

};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
  

   
    <div class="row animated animatedFadeInUp fadeInUp">
      <div class="col-12">
        <div class="card">
          <div class="card-body"> 
            <div class="row">
              <div class="col-6">
                <h4 class="header-title">Comité Copasst</h4>
              </div>

              <div class="col-6 text-right">
                <button type="button" class="btn btn-secondary m-l-5 ml-1" id="tooltip" @click="goBack">
                  <i class="fas fa-arrow-left"></i>
                </button>
                <b-tooltip target="tooltip" placement="left">Volver</b-tooltip>
              </div>
            </div>

           

            <br>
            <b-row>
              <b-col cols="4">
                <b-list-group v-b-scrollspy:listgroup-ex>
                 <!-- <b-list-group-item href="#list-item-1"
                    >¿QUÉ ES EL COMITÉ COPPASST?</b-list-group-item
                  >-->
                  <b-list-group-item href="#list-item-1"
                    >¿Que es el comité copasst? </b-list-group-item
                  >
                  <b-list-group-item href="#list-item-2"
                    >¿Cómo se conforma el COPASST?</b-list-group-item
                  >
                  <!--<b-list-group-item href="#list-item-3"
                    >¿Cuando se conforma el COPASST?</b-list-group-item
                  >
                  <b-list-group-item href="#list-item-4"
                    >¿Cada cuanto se reúnen los integrantes del COPASST?</b-list-group-item
                  >
                     <b-list-group-item href="#list-item-5"
                    >!.1.2</b-list-group-item
                  >
                  <b-list-group-item href="#list-item-6"
                    >1.1.3</b-list-group-item
                  >-->
                  
                 
                </b-list-group>
              </b-col>

              <b-col cols="8">
                <div
                  id="listgroup-ex"
                  style="position: relative; overflow-y: auto; height: 300px"
                >
                  <!--<h4 id="list-item-1">¿Qué es el comité copasst? </h4>
                  <p>...</p>-->
                  <h4 id="list-item-1">¿Que es el comité copasst?</h4>
                   <p>El Comité Paritario de Seguridad y Salud en el Trabajo más conocido como COPASST, está reglamentado en Colombia por la Resolución 2013 de 1986, siendo este organismo un apoyo fundamental para la gestión de la seguridad y salud en el trabajo. </p>
                 
                 
                   <h4 id="list-item-2"> Cómo se conforma el COPASST</h4>
                   <p>  Todas las empresas que cuenten con más de 10 trabajadores deben conformar el COPASST que debe tener representantes por parte de la empresa y de los trabajadores, el número de integrantes se establecerá así: <br /><br />
                  •	De 10 a 49 trabajadores, un representante por cada una de las partes.<br />
                  •	De 50 a 499 trabajadores, dos representantes por cada una de las partes.<br />
                  •	De 500 a 999 trabajadores, tres representantes por cada una de las partes.<br />
                  •	De 1000 o más trabajadores, cuatro representantes por cada una de las partes.<br /><br />

                  Los representantes por parte de los trabajadores deben ser elegidos por votación, mientras que el empleador nombra directamente a sus representantes.<br />
                  Las empresas con menos de 10 trabajadores deben contar con un Vigía de Seguridad y Salud en el Trabajo.<br />
                  Las funciones del comité son las siguientes:<br /><br />

                •	Proponer a la administración de la empresa o establecimiento de trabajo la adopción de medidas y el desarrollo de actividades que procuren y mantengan la salud en los ambientes de trabajo.<br />
                •	Proponer y participar en actividades de capacitación en Seguridad y Salud en el Trabajo dirigidas a trabajadores, supervisores y directivos de la empresa o establecimiento de trabajo.<br />
                •	Colaborar con los funcionarios de entidades gubernamentales de Seguridad y Salud en el Trabajo en las actividades que estos adelanten en la empresa y recibir por derecho propio los informes correspondientes.<br />
                •	Vigilar el desarrollo de las actividades que en materia de medicina, higiene y seguridad industrial debe realizar la empresa de acuerdo al Reglamento de Higiene y Seguridad Industrial y las normas vigentes, promover su divulgación y observancia.<br />
                •	Colaborar en el análisis de las causas de los accidentes de trabajo y enfermedades laborales y proponer al empleador las medidas correctivas a que haya lugar para evitar su ocurrencia, y evaluar los programas que se hayan realizado.<br />
                •	Visitar periódicamente los lugares de trabajo e inspeccionar los ambientes, máquinas, equipos, aparatos y las operaciones realizadas por el personal de trabajadores en cada área o sección de la empresa e informar al empleador sobre la existencia de factores de riesgo y sugerir las medidas correctivas y de control.<br />
                •	Estudiar y considerar las sugerencias que presentan los trabajadores, en materia de medicina, higiene y seguridad industrial.<br />
                •	Servir como organismo de coordinación entre el empleador y los trabajadores en la solución de los problemas relativos a la salud ocupacional. Tramitar los reclamos de los trabajadores relacionados con la Seguridad y Salud en el Trabajo.<br />
                •	Solicitar periódicamente a la empresa informes sobre estadísticas de accidentalidad y enfermedades laborales con el objeto de dar cumplimiento a lo estipulado en la presente resolución.<br />
                •	Elegir al Secretario del Comité<br />
                •	Mantener un archivo de las actas de cada reunión y demás actividades que desarrollen, el cual estará en cualquier momento a disposición del empleador, los trabajadores y las autoridades competentes.<br /><br />

                En el Decreto 1072 de 2015, establece unas funciones especiales para el COPASST, como parte del apoyo en la implementación del Sistema de Gestión de SST:<br /><br />

                •	Apoyo en la identificación de peligros, valoración y evaluación de los riesgos.<br />
                •	Participación en la planificación de la auditoria interna del cumplimiento del Sistema de Gestión de SST.<br />
                •	Participación en la elaboración del programa anual de capacitación.<br />
                </p >
                    
                <!--  <h4 id="list-item-3">Cuando se conforma el COPASST:  </h4>
                  <p>La resolución 2013 de 1986 resuelve que todas las empresas e instituciones, públicas o privadas, que tengan a su servicio diez o más trabajadores, están obligadas a conformar un COPASST, cuya organización y funcionamiento estará de acuerdo con la normatividad al respecto. El comité de COPASST tiene vigencia de dos años; si uno de sus miembros se retira no es necesario hacer una nueva convocatoria, el retiro y/o remplazo del delegado quedara registrado en las actas.  </p>
                  <h4 id="list-item-4">Cada cuanto se reúnen los integrantes del COPASST: </h4>
                  <p>Debe reunir por lo menos una vez al mes a los representantes del COPASST en la empresa y durante la jornada laboral, manteniendo un archivo de las actas de reunión. Es un organismo de promoción y vigilancia de las normas y reglamentos de seguridad y salud en el trabajo dentro de la institución.  <br><br><br><br><br><br><br><br><br><br><br><br> </p>
                  <h4  id="list-item-5">Item 5</h4>
                  <p>{{ text }}</p>
                   <h4 id="list-item-6">Item 6</h4>
                  <p>{{ text }}</p> 
                  
                  <h4 hidden id="list-item-5"></h4>
                  <p>{{ text }}</p>
                   <h4 hidden id="list-item-6"></h4>
                  <p>{{ text }}</p>-->
                </div>
              </b-col>
            </b-row>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>
